
import PetClass from "./Pet";
import UserClass from "./User";
import MerchantClass from "./Merchant";
import MedicineClass from "./Medicine";
import { SupportModel } from "./support-model";
import { ChangelogModel } from "./changelog-model";
import AgendaAlertClass from "./AgendaAlert";

let ModelPet = null;
let ModelUser = null;
let ModelMedicine = null;
let ModelMerchant = null;
let ModelSupport = null;
let ModelChangelog = null;
let ModelAgendaAlert = null;


export function MerchantModel() {
  if (!ModelMerchant) ModelMerchant = new MerchantClass();
  return ModelMerchant;
}
export function UserModel() {
  if (!ModelUser) ModelUser = new UserClass();



  return ModelUser;
}

export function PetModel() {
  if (!ModelPet) ModelPet = new PetClass();


  return ModelPet;
}

export function MedicineModel() {
  if (!ModelMedicine) ModelMedicine = new MedicineClass();

  return ModelMedicine;
}

export function modelSupport() {
  if (!ModelSupport) ModelSupport = new SupportModel();
  return ModelSupport;
}

export function modelChangelog() {
  if (!ModelChangelog) ModelChangelog = new ChangelogModel();
  return ModelChangelog;
}

export function AgendaAlertModel() {
  if (!ModelAgendaAlert) ModelAgendaAlert = new AgendaAlertClass();
  return ModelAgendaAlert;
}
